import { Provider } from '../../config';
import { EventPayload } from '../../events';

export default class AuthTokenEventPayload implements EventPayload {
  provider: Provider;

  civicPassAuthToken: string;

  constructor(civicPassAuthToken: string) {
    this.provider = Provider.WEB;
    this.civicPassAuthToken = civicPassAuthToken;
  }
}
